export let baseURL = "http://waleed.test";

if (process.env.NODE_ENV === "production") {
    baseURL = "https://api2.waleed-mohsen.com";
}

export const dateOptions = { weekday: "long", year: "numeric", month: "short", day: "numeric" };

export const config = {
    baseURL,
    dateOptions,
};
export default config;
